import {ReduxStateType} from '../store';

export const selectHighValueDeductions = (state: ReduxStateType) => {
  return state.highValueDeductions;
};
